enum TranslationFileType {
    Program = 'Program',
    Promotion = 'Promotion',
    Portal = 'Portal',
}

export default TranslationFileType;
